import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HubService } from 'src/services/hub.service';
import { LocalStorage } from 'src/utils/local-storage';
import { CpsNavigationService } from 'src/services/cps-navigation.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { DatalayerService } from 'src/services/datalayer.service';
import { environment } from 'src/environments/environment';
import { AppConstants } from 'src/utils/app.constants';
import { LayoutService } from 'src/app/shared/LayoutService';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  
  @Input() showHeaderButtons: boolean;

  public languageChangeText: string;
  private currentLanguage: string;

  constructor(private hubService: HubService,
    public translationService: TranslateService,
    public localStorage: LocalStorage,
    private cpsNav: CpsNavigationService,    
    public layout: LayoutService,
    private datalayerService: DatalayerService
  ) {
    this.currentLanguage = this.translationService.currentLang;
  }

  ngOnInit(): void {
    this.languageChangeText = this.getLanguageText();
  }

  getLanguageText(): string {
      return this.hubService.getLanguageText(this.currentLanguage);
  }

  changeLang(): void {
    const newLanguage = this.currentLanguage === AppConstants.ENGLISH_CODE ? AppConstants.FRENCH_CODE : AppConstants.ENGLISH_CODE;
      
    // this.datalayerService.languageChangedEvent((this.currentLanguage === AppConstants.ENGLISH_CODE
    //   ? AppConstants.FRENCH_CODE : AppConstants.ENGLISH_CODE));
    
    this.localStorage.setPreferredLang(newLanguage);
    this.languageChangeText = this.hubService.changeLang(this.translationService, this.currentLanguage, this.localStorage);
    this.currentLanguage = newLanguage;
    this.datalayerService.languageChangedEvent(newLanguage);
  }

  goToCps() {
    this.datalayerService.goToCPSClickHeader(environment.CPS2_DOMAIN, "Go To CPS");
    this.cpsNav.goToCps();
  }

  logout(): void {
    this.cpsNav.logout();
  }

  // Drop down menu code
  @ViewChild('userDropdown') userDropdown: NgbDropdown;
  declare userTimeout: ReturnType<typeof setTimeout>;

  public hoverOnUser(): void {
    this.userTimeout = setTimeout(() => 
      { this.userDropdown.open() }
    , 30);
  }
  public leaveUserDropdown(): void {
    if (!!this.userDropdown){
      this.userDropdown.close();
      clearTimeout(this.userTimeout);
    }
  }

  public onUtilNavMouseLeave(): void {
    if (!!this.userDropdown) {
      this.userDropdown.close();
    }
  }
  @HostListener('window:focus', ['$event'])
  onFocus(): void {
    // This is to close all opened dropdowns when user return from switching tabs 
    // otherwise, the dropdowns will sometimes stay open and it's weird
    this.leaveUserDropdown();
  }
}